import { intervalToDuration } from 'date-fns';

export type CutOffStatus = undefined | 'Missed' | 'Urgent';

export function getCutOffStatus(next: Date | undefined, now: Date): CutOffStatus {
  if (next === undefined) {
    return undefined;
  }
  if (next < now) {
    const { hours = 0, minutes = 0 } = intervalToDuration({ start: next, end: now });
    if (hours === 0 && minutes <= 5) {
      return 'Missed';
    }
  }
  if (next > now) {
    const { hours = 0, minutes = 0 } = intervalToDuration({ start: now, end: next });
    if (hours === 0 && minutes <= 10) {
      return 'Urgent';
    }
  }
  return undefined;
}
